import {
  BoardContainer,
  TitleContainer
} from "../../assets/GlobalStyles";
import {accountInfoRevenue, accountProfile,} from "./entity";
import React, {useCallback, useEffect} from "react";
import {useAtom, useSetAtom} from "jotai";
import {accountRevenueStatus, accountUserProfile} from "../../services/account/AccountAdminAxios";
import {AdminInfo} from "../layout";
import {tokenResultAtom} from "../login/entity";
import {useParams} from "react-router-dom";
import {
  userAccountProfile,
  userAccountRevenueStatus
} from "../../services/account/AccountUserAxios";
import AccountManage from "./AccountManage";
import AccountHistory from "./AccountHistory";
import AccountProfile from "./AccountProfile";
import AccountConfirm from "./AccountConfirm";
import AccountData from "./AccountData";

export default function Account(){
  const params = useParams()
  const [tokenResultInfo] = useAtom(tokenResultAtom)
  const [adminInfoState] = useAtom(AdminInfo) //매체 전환 계정 정보
  const setAccountProfileState = useSetAtom(accountProfile) //프로필 조회
  const setRevenueState = useSetAtom(accountInfoRevenue) //수익 현황

  const handleAdminApi = useCallback((userName) => {
    accountRevenueStatus(userName).then(response => {
      setRevenueState(response);
    });
  }, [setRevenueState]);

  useEffect(() => {
    if (tokenResultInfo.role !== 'NORMAL') {
      if (adminInfoState.convertedUser !== '') {
        accountUserProfile(adminInfoState.convertedUser).then(response => {
          setAccountProfileState(response);
          handleAdminApi(adminInfoState.convertedUser);
        });
      } else {
        setAccountProfileState(null);
        handleAdminApi('');
      }

      return;
    }
    userAccountProfile(tokenResultInfo.username).then(response => {
      setAccountProfileState(response);

      if (response !== null) {
        userAccountRevenueStatus(tokenResultInfo.username).then(response => {
          setRevenueState(response);
        });
      }
    });
  }, [
    adminInfoState.convertedUser,
    handleAdminApi,
    setAccountProfileState,
    setRevenueState,
    tokenResultInfo.role,
    tokenResultInfo.username,
  ]);

  return(
    <main>
      <BoardContainer>
        <TitleContainer>
          <div>
            <h1>정산 관리</h1>
          </div>

        </TitleContainer>

        {params.id === 'account' && <AccountManage/>}
        {params.id === 'accountHistory' && <AccountHistory />}
        {params.id === 'accountProfile' && <AccountProfile />}
        {params.id === 'accountConfirm' && <AccountConfirm />}
        {params.id === 'accountData' && <AccountData />}
      </BoardContainer>

    </main>
  )
}
